<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Article Categories'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Article Categories'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'slug',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'articleCategories/index',
            deleteItem: 'articleCategories/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/article-categories/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/article-categories/add');
        }
    }
};
</script>
